const hotjar = require('./hotjar');

module.exports = {
    hotjar: {
        initialize: function initialize(id, sv) {
            hotjar(id, sv);
        }
    }
};
